import React, { Component, Fragment } from 'react';
import ReactTable from 'react-table';
import NotificationSystem from 'react-notification-system';
import { BeatLoader } from 'react-spinners';
import moment from 'moment';
//import Modal from 'react-modal'
//import Datetime from 'react-datetime';
import { currency_symbol, date_format } from '../../../../server/constants';
import TmExportExcel from '../../../Misc/tmExportExcel/tmExportExcel';
import { get } from '../../../../server/actions';
import {
    _addNotificationError, groupBy, showFile, getSchoolGrades,
    convertTwoDecimalPoint, _addNotification,
} from '../../../../server/util'
import DateTimeRangePicker from '../../../Misc/DateTimeRangePicker'
const _ = require('lodash');

class StripeReconciliationreport extends Component {
    constructor(props) {
        // console.log("props:::::::::",props);
        super(props);
        this.state = {
            loading: false,
            data: [],
            startDate: moment(),
            endDate: moment(),
            dataFilter: { tdate: 'D', sdate: new Date(), edate: new Date() },
            selectedDates: {
                startDate: moment(moment((this.props.activeMonth || moment()), 'YYYYMM')).startOf('month'),
                endDate: moment(moment((this.props.activeMonth || moment()), 'YYYYMM')).endOf('month')
            },
        }
    }
    componentDidMount() {
        this._notificationSystem = this.refs.notificationSystem;
        this.getStripeReconciliationData(this.state.selectedDates.startDate, this.state.selectedDates.endDate);

    }
    onChangeDateRange = (startDate, endDate) => {
        console.log("StartDate::::", startDate);
        console.log("EndDate::::", endDate);
        let _selectedDate = { startDate: startDate, endDate: endDate }
        this.setState({ selectedDates: _selectedDate },
            this.getStripeReconciliationData(startDate, endDate)
        );
    }

    getStripeReconciliationData = (startDate, endDate, isPdf = false) => {
        let userInfo = JSON.parse(sessionStorage.getItem('loggedInUserInfo'));
        const { mealType, } = this.state;
        this.setState({ loading: true });
        const sDate = moment(startDate).startOf('D');
        const eDate = moment(endDate).endOf('D')
        let url = ''
        if (isPdf) {
            url = `/reports/${userInfo.schoolId}/reconciliationOnlineTrx/${sessionStorage.getItem('schoolYearValue')}?startDate=${moment(sDate).utc().format("YYYY-MM-DD")}&endDate=${moment(eDate).utc().format("YYYY-MM-DD")}&fileType=pdf&access_token=`;
        } else {
            url = `/reports/${userInfo.schoolId}/reconciliationOnlineTrx/${sessionStorage.getItem('schoolYearValue')}?startDate=${moment(sDate).utc().format("YYYY-MM-DD")}&endDate=${moment(eDate).utc().format("YYYY-MM-DD")}&access_token=`;
        }

        get(url).then((response) => {
            if (!response.ok) {
                if (response.status === 417) {
                    return response.json();
                }
                //throw Error(response.errorMessage);
            }
            console.log('response', response);
            return response;
        }).then(res => {
            if (res.statusCode === 417) {
                // _addNotificationError(res.statusMessage,this)
                throw Error(res.statusMessage);
            } else if (!res.statusCode === 200) {
                throw Error(res.errorMessage);
            } else {
                if (isPdf) {
                    return res.blob();
                } else {
                    return res.json();
                }
            }
        }).then(data => {
            if (isPdf) {
                let filename = 'Stripe_Reconciliation_Data.pdf';
                showFile(data, filename);
                this.setState({ loading: false });
            } else {
                this.setState({
                    data: data.resp, loading: false
                })
            }
        }).catch(
            (error) => {
                let msg = ''
                if (typeof error === 'string') {
                    msg = error;
                } else {
                    msg = error.message;
                }
                _addNotificationError(msg, this);
                this.setState({ loading: false })
            }
        );
    }

    buildStripeRecReportFormatForExport = () => {
        let fData = [];
        let result = [];
        (this.state.data || []).map(row => {
            fData.push([
                row.idNumb,
                row.studentId,
                row.studentLName + ' ' + row.studentFName,
                row.transactionDate,
                row.transactionTime,
                row.amount,
                row.transactionDesc,
                row.note,
                row.user,
                row.itemPurchased,
                row.grade,
                row.paymentType,
                row.checkNum,
                row.transferId,
                row.schoolName,
                row.category,
                row.location,
                row.pin,
                row.donationMealCount
            ]);
        });

        result.push(
            {
                columns: ['Id', 'Student Id', 'Student', 'Transaction Date', 'Transaction Time', 'Amount', 'Transaction Desc', 'Note', 'User', 'Item Purchased', 'Grade', 'Payment Type', 'Check Num', 'Transfer Id', 'School Name', 'Category', 'Location', 'Pin', 'Donation Meal Count'],
                data: fData
            }
        );
        return result;

    }
    renderInput = (props, openCalendar, closeCalendar) => {
        return (
            <div>
                <input {...props} />
                <button type="button" className="input-group-addon" onClick={openCalendar}>
                    <i className="fa fa-calendar"> </i>
                </button>
            </div>
        );
    }
    setDate = (e) => {
        //alert(e)
        this.refs.calendar.closeCalendar()
        this.setState({ startDate: e }, () => {
            this.getStripeReconciliationData()
        })
    }

    render() {
        const checkboxProps = {
            getTheadProps: () => {
                return {
                    style: {
                        backgroundColor: "#D2D7D4", fontWeight: 'bold'
                        // color: selected ? 'white' : 'inherit',
                    },
                    className: "bg-success base-reverse"
                };
            },
            getTableProps: () => {
                return {
                    className: "table table-hover"
                }
            },
        };


        return (
            <Fragment>
                <NotificationSystem ref="notificationSystem" />
                <div className='sweet-loading'
                    style={{ position: 'fixed', top: '50%', left: '48%', zIndex: '1000' }}>
                    <BeatLoader
                        size={20}
                        color={'#ea7066'}
                        loading={this.state.loading}
                    />
                </div>
                <div className="panel panel-p1 panel-primary">

                    <div className="panel-heading text-center">
                        <h3 className="panel-title" style={{ display: 'inline' }}>Stripe Reconciliation report</h3>
                        <div style={{
                            display: 'inline-block',
                            backgroundColor: 'transparent',
                            marginTop: '-7px',
                            float: 'right',
                            borderRadius: '3px'
                        }}>
                            <div className="btn-group">
                                <button className="btn-link btn-sm dropdown-toggle" type="button"
                                    data-toggle="dropdown" aria-haspopup="true" aria-expanded="false" style={{ color: '#fff', fontSize: '13px' }}>
                                    <i className="fa fa-file" aria-hidden="true"></i> Export <span className="caret"></span>
                                </button>
                                <ul className="dropdown-menu">
                                    <li>
                                        <a title="Click to Download PDF" style={{ cursor: 'pointer' }}
                                            onClick={() => { this.getStripeReconciliationData(this.state.selectedDates.startDate, this.state.selectedDates.endDate, true); }}
                                            target='_blank'
                                        ><i className="fa fa-file-pdf-o" /> Pdf</a>
                                    </li>
                                    <li>
                                        <TmExportExcel id="stripeReconciliationReport"
                                            name={"Stripe Reconciliation report"}
                                            filename={"Stripe Reconciliation report"}
                                            element={<a title="Click to Download Excel" id="stripeReconciliationReport"
                                                style={{
                                                    display: 'block',
                                                    padding: '3px 20px',
                                                    clear: 'both',
                                                    fontWeight: '400',
                                                    lineHeight: 1.42857143,
                                                    color: '#333',
                                                    whiteSpace: 'nowrap',
                                                    cursor: 'pointer'
                                                }}
                                            ><i className="fa fa-file-excel-o" /> Excel</a>}
                                            dataSet={this.buildStripeRecReportFormatForExport()}
                                        />
                                    </li>

                                </ul>
                            </div>
                        </div>
                    </div>
                    <div className="panel-body">
                        <div className='row'>
                            <div className='col-md-2' style={{ marginTop: '4px' }}>
                                <label>Select date range:</label>
                            </div>
                            <div className='col-md-3' style={{ marginTop: '4px' }}>
                                <DateTimeRangePicker
                                    startDate={this.state.selectedDates.startDate}
                                    endDate={this.state.selectedDates.endDate}
                                    isReport={false}
                                    applyCallback={(event, picker) => {
                                        this.onChangeDateRange(picker.startDate, picker.endDate)
                                    }}
                                    isDateShow={true} />
                            </div>
                        </div>
                        <div className='row' >
                            <div className="col-md-12" style={{ marginTop: '4px' }}>
                                <ReactTable ref={(r) => this.deptTable = r} id={'deptTbl'}
                                    filterable
                                    columns={[
                                        {
                                            Header: "Id",
                                            id: "idNumb",
                                            style: { textAlign: 'left' },
                                            accessor: row => {
                                                return (
                                                    <span>
                                                        {row.idNumb}
                                                    </span>
                                                );
                                            },
                                            filterMethod: (filter, row) => {
                                                const _row = row._original
                                                return (_row.idNumb).toString().startsWith(filter.value)
                                            }
                                        },
                                        {
                                            Header: "Student First Name",
                                            id: "studentFName",
                                            style: { textAlign: 'center' },
                                            accessor: 'studentFName',
                                            filterMethod: (filter, row) => {
                                                const _row = row._original
                                                return (_row.studentFName || '').toLowerCase().startsWith(filter.value.toLowerCase())
                                            },
                                        }, {
                                            Header: "Student Last Name",
                                            id: "studentLName",
                                            style: { textAlign: 'center' },
                                            accessor: 'studentLName',
                                            filterMethod: (filter, row) => {
                                                const _row = row._original
                                                return (_row.studentLName || '').toLowerCase().startsWith(filter.value.toLowerCase())
                                            },
                                        }, {
                                            Header: 'Transaction Date',
                                            id: 'transactionDate',
                                            width: 150,
                                            accessor: row => {
                                                return (
                                                    <div style={{ textAlign: "center" }}>
                                                        {moment(row.transactionDate).isValid() ? moment(row.transactionDate).format(`${date_format()}`) : ''}
                                                    </div>
                                                );
                                            },
                                            filterMethod: (filter, row) => {
                                                const _row = row._original
                                                return (_row['transactionDate']).startsWith(filter.value.toLowerCase())
                                            },

                                        }, {
                                            Header: 'Transaction Time',
                                            accessor: 'transactionTime',
                                            width: 200,
                                            filterMethod: (filter, row) => {
                                                const _row = row._original
                                                return (_row['transactionTime']).startsWith(filter.value.toLowerCase())
                                            },
                                        },
                                        {
                                            Header: `Amount (${currency_symbol()})`,
                                            id: 'amount',
                                            width: 100,
                                            filterable: false,
                                            accessor: row => {
                                                return (
                                                    <div style={{ textAlign: "center" }}>
                                                        {currency_symbol() + ' ' + convertTwoDecimalPoint(row.amount)}
                                                    </div>
                                                );
                                            },
                                        },
                                        {
                                            Header: 'Transaction Desc',
                                            accessor: 'transactionDesc',
                                            width: 100,
                                            filterMethod: (filter, row) => {
                                                const _row = row._original
                                                return (_row.transactionDesc || '').toLowerCase().startsWith(filter.value.toLowerCase())
                                            }
                                        },
                                        {
                                            Header: 'Note',
                                            accessor: 'note',
                                            width: 100,
                                            filterMethod: (filter, row) => {
                                                const _row = row._original
                                                return (_row.note || '').toLowerCase().startsWith(filter.value.toLowerCase())
                                            }
                                        },
                                        {
                                            Header: "User",
                                            accessor: "user",
                                            style: { textAlign: 'center' },
                                            width: 100,
                                            filterMethod: (filter, row) => {
                                                const _row = row._original
                                                return (_row[filter.id]).toLowerCase().startsWith(filter.value.toLowerCase())
                                            }
                                        },
                                        {
                                            Header: 'Item Purchased',
                                            accessor: 'itemPurchased',
                                            width: 100,
                                            filterMethod: (filter, row) => {
                                                const _row = row._original
                                                return (_row.itemPurchased || '').toLowerCase().startsWith(filter.value.toLowerCase())
                                            }
                                        },
                                        {
                                            Header: "Grade",
                                            accessor: "grade",
                                            style: { textAlign: 'center' },
                                            width: 100,
                                            filterMethod: (filter, row) => {
                                                const _row = row._original
                                                return (_row.grade).toLowerCase().startsWith(filter.value.toLowerCase())
                                            }
                                        },
                                        {
                                            Header: 'Payment Type',
                                            accessor: 'paymentType',
                                            width: 100,
                                            filterMethod: (filter, row) => {
                                                const _row = row._original
                                                return (_row.paymentType).toLowerCase().startsWith(filter.value.toLowerCase())
                                            }
                                        },
                                        {
                                            Header: 'Check Num',
                                            accessor: 'checkNum',
                                            width: 100,
                                            filterMethod: (filter, row) => {
                                                const _row = row._original
                                                return (_row.checkNum || '').toLowerCase().startsWith(filter.value.toLowerCase())
                                            }
                                        },
                                        {
                                            Header: 'Transfer Id',
                                            accessor: 'transferId',
                                            width: 100,
                                            filterMethod: (filter, row) => {
                                                const _row = row._original
                                                return (_row.transferId).toLowerCase().startsWith(filter.value.toLowerCase())
                                            }
                                        },
                                        {
                                            Header: 'School Name',
                                            accessor: 'schoolName',
                                            width: 100,
                                            filterMethod: (filter, row) => {
                                                const _row = row._original
                                                return (_row.schoolName || '').toLowerCase().startsWith(filter.value.toLowerCase())
                                            }
                                        },
                                        {
                                            Header: 'Category',
                                            accessor: 'category',
                                            width: 100,
                                            filterMethod: (filter, row) => {
                                                const _row = row._original
                                                return (_row.category || '').toLowerCase().startsWith(filter.value.toLowerCase())
                                            }
                                        },
                                        {
                                            Header: 'Location',
                                            accessor: 'location',
                                            width: 100,
                                            filterMethod: (filter, row) => {
                                                const _row = row._original
                                                return (_row.location || '').toLowerCase().startsWith(filter.value.toLowerCase())
                                            }
                                        },
                                        {
                                            Header: 'Pin',
                                            id: 'pin',
                                            width: 100,
                                            accessor: row => {
                                                return (
                                                    <span>
                                                        {row.pin}
                                                    </span>
                                                );
                                            },
                                            filterMethod: (filter, row) => {
                                                const _row = row._original
                                                return (_row.pin).toLowerCase().startsWith(filter.value.toLowerCase())
                                            }
                                        },
                                        {
                                            Header: 'Donation Meal Count',
                                            accessor: 'donationMealCount',
                                            width: 100,
                                            filterMethod: (filter, row) => {
                                                const _row = row._original
                                                return (_row.donationMealCount || '').toLowerCase().startsWith(filter.value.toLowerCase())
                                            }
                                        },

                                    ]}
                                    data={_.orderBy(this.state.data, ['studentLName', 'studentFName'], ['asc'])}
                                    defaultPageSize={10} className="-striped -highlight" {...checkboxProps} />
                            </div>
                        </div>
                    </div>
                </div>
            </Fragment>
        );
    }
}

export default StripeReconciliationreport;


// WEBPACK FOOTER //
// ./src/components/SchoolAdmin/Reports/FinancialReport/stripeReconciliationreport.jsx